export default __webpack_public_path__ + "static/media/Design.68e7000c.svg";